@if (vs.currentBidVehicle(); as vehicle) {
<div class="modal-overlay" [class.closing]="closing()" (click)="close()">
  <div class="modal" [class.closing]="closing()" (click)="$event.stopPropagation()">
    <div class="modal-header">
      <div>
        <div class="modal-title">Nieuw bod</div>
        <div class="modal-subtitle">{{ vehicle.VehicleSpecification?.Vehicle?.make || '' }} {{ vehicle.VehicleSpecification?.Vehicle?.model || '' }} {{ vehicle.VehicleSpecification?.type || '' }}</div>
      </div>
      <button class="close-btn" (click)="close()">
        <app-icon name="x" size="md" />
      </button>
    </div>
    <div class="modal-body">
      <div class="vehicle-info-strip">
        @if (vehicle.VehicleSpecification?.Vehicle?.year) {
          <div class="vehicle-info-chip">
            <app-icon name="calendar" size="xs" />
            {{ vehicle.VehicleSpecification?.Vehicle?.year }}
          </div>
        }
        @if (vehicle.VehicleSpecification?.mileage) {
          <div class="vehicle-info-chip">
            <app-icon name="gauge" size="xs" />
            {{ vehicle.VehicleSpecification?.mileage | number:'1.0-0':'nl' }} km
          </div>
        }
        @if (vehicle.VehicleSpecification?.FuelType?.descriptionNl) {
          <div class="vehicle-info-chip">
            <app-icon name="fuel" size="xs" />
            {{ vehicle.VehicleSpecification?.FuelType?.descriptionNl }}
          </div>
        }
        @if (vehicle.VehicleSpecification?.ColorType?.descriptionNl) {
          <div class="vehicle-info-chip">
            <app-icon name="palette" size="xs" />
            {{ vehicle.VehicleSpecification?.ColorType?.descriptionNl }}
          </div>
        }
        @if (vehicle.VehicleSpecification?.TransmissionType?.descriptionNl) {
          <div class="vehicle-info-chip">
            <app-icon name="settings-2" size="xs" />
            {{ vehicle.VehicleSpecification?.TransmissionType?.descriptionNl }}
          </div>
        }
      </div>
      <div class="bid-delivery">
        <app-icon name="calendar" size="sm" />
        <span class="bid-delivery-label">Verwachte leverdatum</span>
        <span class="bid-delivery-value">{{ (vehicle.dateDelivery?.date | nlDate:'dd-MM-yyyy') || 'Onbekend' }}</span>
        @if (daysUntilDelivery(); as days) {
          <span class="bid-delivery-days">{{ days }} dagen</span>
        }
      </div>
      @if (vehicle.MyBid?.bid != null || (vehicle.MyPreviousBids?.length ?? 0) > 0) {
      <div class="bid-history">
        <div class="bid-history-title">Biedingen</div>
        @if (vehicle.MyBid?.bid != null) {
        <div class="bid-history-item bid-history-item--current">
          <div class="bid-history-row">
            <span class="bid-history-amount">{{ vehicle.MyBid!.bid | nlCurrency }}</span>
            @if (vehicle.MyBid!.created) {
            <span class="bid-history-date">{{ vehicle.MyBid!.created!.date | nlDate }}</span>
            }
          </div>
          @if (vehicle.MyBid!.Person) {
          <span class="bid-history-person">{{ vehicle.MyBid!.Person!.firstName }} {{ vehicle.MyBid!.Person!.infix }} {{ vehicle.MyBid!.Person!.lastName }}</span>
          }
          @if (vehicle.MyBid!.comment) {
          <span class="bid-history-comment">{{ vehicle.MyBid!.comment }}</span>
          }
        </div>
        }
        @for (prev of (vehicle.MyPreviousBids ?? []); track prev.id) {
        <div class="bid-history-item">
          <div class="bid-history-row">
            <span class="bid-history-amount bid-history-amount--prev">{{ prev.bid | nlCurrency }}</span>
            @if (prev.created) {
            <span class="bid-history-date">{{ prev.created.date | nlDate }}</span>
            }
          </div>
          @if (prev.Person) {
          <span class="bid-history-person">{{ prev.Person.firstName }} {{ prev.Person.infix }} {{ prev.Person.lastName }}</span>
          }
          @if (prev.comment) {
          <span class="bid-history-comment">{{ prev.comment }}</span>
          }
        </div>
        }
      </div>
      }
      <app-bid-form
        [vehicle]="vehicle"
        [hasNext]="hasNext"
        [showCurrentBid]="false"
        (bidPlaced)="onBidPlaced()"
        (bidPlacedAndNext)="onBidPlacedAndNext(vehicle)">
        <button slot="cancel" class="btn-cancel" (click)="close()">Annuleren</button>
      </app-bid-form>
    </div>
  </div>
</div>
}
